import { ContentManager } from './ContentManager';
import { DrawersPanel } from './DrawersPanel';
import { AdminWelcome } from './AdminWelcome';

// Content: everything that feeds the app's surfaces. Posts (the publishing
// dashboard), the closet drawer door images, and the founding-member welcome
// video. Banners were retired (legacy, unused).

function cls(on: boolean) {
  return on ? 'admin__subpanel' : 'admin__subpanel admin__panel--hidden';
}

export function ContentSection({ tab, meId }: { tab: string; meId: string }) {
  return (
    <>
      <div className={cls(tab === 'posts')}>
        <ContentManager active={tab === 'posts'} />
      </div>
      <div className={cls(tab === 'drawers')}>
        <DrawersPanel active={tab === 'drawers'} />
      </div>
      <div className={cls(tab === 'welcome')}>
        <AdminWelcome active={tab === 'welcome'} me={{ id: meId }} />
      </div>
    </>
  );
}
